(() => {
  function initCart() {
    const cart = document.querySelector('[data-lamaa-whop-cart]');
    if (!cart || cart.dataset.ready) return;
    cart.dataset.ready = 'true';
    const panel = cart.querySelector('.lm-whop-cart__panel');
    const expressButton = cart.querySelector('[data-express-toggle]');
    const expressCard = cart.querySelector('[data-express-card]');
    const protection = cart.querySelector('[data-protection-toggle]');
    const checkout = cart.querySelector('[data-cart-checkout]');
    const total = cart.querySelector('[data-cart-total]');
    let express = false;
    let returnFocus = null;

    function refresh() {
      const cents = 189999 + (express ? 19999 : 0) + (protection.checked ? 14999 : 0);
      const key = express && protection.checked ? 'checkoutBoth' : express ? 'checkoutExpress' : protection.checked ? 'checkoutProtection' : 'checkoutBase';
      total.textContent = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(cents / 100);
      checkout.href = cart.dataset[key] || cart.dataset.checkoutBase;
      expressButton.textContent = express ? 'Eklendi ✓' : 'Ekle +';
      expressButton.setAttribute('aria-pressed', String(express));
      expressCard.classList.toggle('is-selected', express);
    }
    function open(event) {
      event?.preventDefault();
      returnFocus = event?.currentTarget || document.activeElement;
      cart.hidden = false;
      document.body.classList.add('lm-whop-cart-open');
      document.querySelectorAll('[data-lamaa-cart-count]').forEach(count => { count.textContent = '1'; });
      refresh();
      panel.focus();
    }
    function close() {
      cart.hidden = true;
      document.body.classList.remove('lm-whop-cart-open');
      returnFocus?.focus();
    }
    document.querySelectorAll('[data-lamaa-cart-open]').forEach(button => button.addEventListener('click', open));
    cart.querySelectorAll('[data-lamaa-cart-close]').forEach(button => button.addEventListener('click', close));
    expressButton.addEventListener('click', () => { express = !express; refresh(); });
    protection.addEventListener('change', refresh);
    document.addEventListener('keydown', event => {
      if (cart.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'Tab') {
        const focusable = [...panel.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')];
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart);
  else initCart();
  document.addEventListener('shopify:section:load', initCart);
})();
